export function NotificationBadge({ count }: { count: number }) {
  if (count === 0) return null;
  return (
    <span data-testid="notification-badge" className="absolute -top-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full">
      {count > 9 ? '9+' : count}
    </span>
  );
}
